<template>
    <b-card class="text-center">
      <b-avatar
        class="mb-1"
        variant="light-info"
        size="45"
      >
        <feather-icon
          size="21"
          icon="BarChart2Icon"
        />
      </b-avatar>
      <div class="truncate">
        <h2 class="mb-25 font-weight-bolder">
          {{ statistic }}
        </h2>
        <span>{{ $t('events_by_employees') }}</span>
      </div>
    </b-card>
  </template>
  
  <script>
  import { BCard, BAvatar } from 'bootstrap-vue'
  
  export default {
    components: {
      BCard,
      BAvatar,
    },
    props: {
      statistic: {
        type: [Number, String],
        required: true,
      },
    },
  }
  </script>
  